<template>
	<div class="field">
		<slot />

		<input
			ref="autocomplete"
			:id="inputId"
			:placeholder="''"
			v-model="text"
			@focus="onFocus"
			@blur="onBlur"
			@input="onInput">

<!--		:label="label"-->
<!--		-->

		<div v-if="$slots.suffix" class="suffix">
			<slot name="suffix" />
		</div>
	</div>
</template>
<style lang="scss">
	.pac-container{
		border:none;
		padding:0;
		margin:0;
		font-family: 'Open Sans', sans-serif;
		border-radius: 5px;
	}
	.pac-icon{

	}
	.pac-item{
		/*background:orange;*/
		padding: 8px 16px;
		position:relative;
		cursor: pointer;
	}
	.pac-item:hover{
		/*background:green;*/
	}
	.pac-icon{
		display: none!important;
	}

	.pac-item > span{
		display:block;
		text-overflow: ellipsis;
		overflow: hidden;
		line-height: 16px;
	}

	.pac-item:hover{

	}
	.pac-item-selected{

	}
	.pac-item-query{

	}
	.pac-matched{
		/* color:red; */
		font-weight: inherit;
	}

	.pac-logo::after{
		border-top: 1px solid #e6e6e6;
		padding: 24px 16px;
		background-position: calc(100% - 16px) 50%;
		/*display:none;*/
	}

</style>

<script>
	export default{
		name:'adresse-input',
		props:{
			inputId:{},
			label:{},
			placeholder:{default:'Adresse'},
		},
		data: function() {
			return {
				form: {},
				inputFocused: false,
				autocomplete: null,
				text: null,
				complet: null,
			}
		},
		watch:{
			// adresse(datas){
			// 	console.log("datas", datas);
			// 	this.form = this.full;
			// },
			value:function(value){
				this.text = value && value.autocomplete ? value.autocomplete : '';
			}
		},

		mounted() {
			// Create the autocomplete object, restricting the search predictions to geographical location types.
			this.autocomplete = new google.maps.places.Autocomplete(
				this.$refs.autocomplete,
				{
					types: ["geocode"],
					// { types: ["address"] }
					componentRestrictions: {country: 'fr'},
				},
			);
			// Avoid paying for data that you don't need by restricting the set of
			// place fields that are returned to just the address components.
			// this.autocomplete.setFields(["address_component"]);
			this.autocomplete.setFields(['address_component','geometry','formatted_address']);

			// When the user selects an address from the drop-down, populate the
			// address fields in the form.
			this.autocomplete.addListener("place_changed", function() {
				// Get the place details from the autocomplete object.
				let place = this.autocomplete.getPlace();

				this.reset();
				let adresse = {
					adresse:null,
					cp:null,
					ville:null,
					region:null,
					pays:null,
					pays_code:null,
					lon: null,
					lat: null,
					autocomplete: null,
				};
				
				for (let component of place.address_components) {
					switch (component.types[0]) {
						case 'street_number': adresse.adresse = component.short_name + (adresse.adresse ? ' '+adresse.adresse : ''); break;
						case 'route': adresse.adresse = (adresse.adresse ? adresse.adresse+' ' : '') + component.long_name; break;
						case 'postal_town': adresse.ville = component.long_name; break;
						case 'locality': adresse.ville = component.long_name; break;
						case 'administrative_area_level_1': adresse.region = component.long_name; break;
						case 'postal_code': adresse.cp = component.short_name; break;
						case 'country':
							adresse.pays = component.long_name;
							adresse.pays_code = component.short_name;
							break;
					}
				}

				adresse.lat = place.geometry.location.lat();
				adresse.lon = place.geometry.location.lng();

				// console.log(place);
				// console.log(adresse);
				this.complet = adresse.adresse && adresse.ville && adresse.cp && adresse.pays_code;
				if(this.complet){
					adresse.autocomplete = place.formatted_address;
					this.text = place.formatted_address;
					this.$emit('input', adresse);
				}
			}.bind(this));
		},

		methods:{
			// Bias the autocomplete object to the user's geographical location,
			// as supplied by the browser's 'navigator.geolocation' object.
			geolocate() {
				if (navigator.geolocation) {
					navigator.geolocation.getCurrentPosition(function(position){
						const geolocation = {
							lat: position.coords.latitude,
							lng: position.coords.longitude,
						};
						const circle = new google.maps.Circle({
							center: geolocation,
							radius: position.coords.accuracy,
						});
						this.autocomplete.setBounds(circle.getBounds());
					}.bind(this));
				}
			},

			reset(){
				// this.$emit('input', {});
			},

			onBlur(e){
				this.inputFocused = false;
				this.$emit('blur', e);
				if(!this.complet){
					this.$emit('input', {});
					this.text = '';
				}
			},
			onFocus(e){
				this.inputFocused = true;
				this.$emit('focus', e);
			},
			onInput(e){
				this.complet = false;
				this.$emit('input', {});
			}
		}
	}
</script>
